import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SustainabilityPreAssessmentManagementStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .table-wrapper {
    margin-top: 21px;
  }

  .table {
    .table-row {
      .id {
        flex: 0 0 9%;
        justify-content: center;
        text-align: center;
      }

      .file-name {
        flex: 1 1 auto;
      }

      .active {
        flex: 0 0 10%;
        justify-content: center;
        align-items: center;
        display: flex;
      }

      .actions {
        flex: 0 0 10%;
        & > .section {
          justify-content: center;
        }
      }

      .table-column {
        &.actions {
          padding-left: 15px;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
